import { render, staticRenderFns } from "./winning.vue?vue&type=template&id=62997978&scoped=true&"
import script from "./winning.vue?vue&type=script&lang=js&"
export * from "./winning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62997978",
  null
  
)

export default component.exports